module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0095.jpg?v=4e2c4a5b";